exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".nav-button[data-v-4035b7ca]{-webkit-appearance:none;position:relative;display:block;border:0;margin:0;padding:0 10px;background-color:transparent;width:100%;text-align:left;color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4035b7ca","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/NavButton.vue
// module id = 24
// module chunks = 0